/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import { any, all } from 'cio/app-models/conditions/group';
import AuthService from 'cio/services/auth';
import AttributeCondition from 'cio/app-models/conditions/attribute';
import { action } from '@ember/object';

type CioConditionEditorEventDataFilterArgs = {
  allowComparisonOperator: boolean;
  attributeNames: string[];
  filters: AttributeCondition;
  filterOperator: 'and' | 'or';
  showButton: boolean;
  showDateInequalityOperators: boolean;
  onAddFilter: () => unknown;
  onRemove: (filter: AttributeCondition) => unknown;
  onDuplicate: (filter: AttributeCondition) => unknown;
  onConditionChange?: () => unknown;
  canDuplicate?: boolean;
  disabled?: boolean;
  eventName?: string;
  depth: number;
};

export default class CioConditionEditorEventDataFilter extends Component<CioConditionEditorEventDataFilterArgs> {
  @service auth!: AuthService;

  get groupTypes() {
    return [
      { value: all, label: 'all' },
      { value: any, label: 'at least one' },
    ];
  }

  get showButton() {
    return this.args.showButton ?? true;
  }

  get onConditionChange() {
    return this.args.onConditionChange ?? function () {};
  }

  get depth() {
    return this.args.depth ?? 0;
  }

  get depthClassModifier() {
    return `${this.depth % 2 === 0 ? 'even' : 'odd'}`;
  }

  get nextDepthClassModifier() {
    return `${(this.depth + 1) % 2 === 0 ? 'even' : 'odd'}`;
  }

  @action
  onDuplicate(filter: AttributeCondition) {
    this.args.onDuplicate?.(filter);
  }
}
